<template>
    <div class="no-notes">
        <img
          class="no-notes__img"
          src="../../assets/images/no.png"
          alt="no notes"
        >
        <div class="no-notes__text">No notes</div>
    </div>
</template>

<script>
export default {
  name: 'NoNotes'
}
</script>

<style lang="stylus" scoped>
@import '~@/css/vars.styl'

.no-notes
  opacity .4
  margin auto
  display flex
  flex-direction column
  justify-content center
  align-items center
  user-select none

  &__img
    max-width 85%

  &__text
    font-size 24px
</style>
